import { FeedbackWord } from 'http/Api/Feedback/types';

const WORDS_POSITIVE: FeedbackWord[] = [
  'delicious',
  'clean',
  'fastService',
  'friendlyStaff',
];
const WORDS_NEGATIVE: FeedbackWord[] = [
  'longWait',
  'poorQuality',
  'wrongArticle',
];

export const getFeedbackWordStatus = (word: FeedbackWord) => {
  if (WORDS_POSITIVE.includes(word)) return 'positive';
  if (WORDS_NEGATIVE.includes(word)) return 'negative';
  return 'default';
};
